import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _c0fc0b5a = () => interopDefault(import('../nuxt/pages/~404.vue' /* webpackChunkName: "" */))
const _47df9bf0 = () => interopDefault(import('../nuxt/pages/~top.vue' /* webpackChunkName: "" */))
const _976be978 = () => interopDefault(import('../nuxt/pages/~login.vue' /* webpackChunkName: "" */))
const _32e61718 = () => interopDefault(import('../nuxt/pages/~register.vue' /* webpackChunkName: "" */))
const _175067ba = () => interopDefault(import('../nuxt/pages/~callback.vue' /* webpackChunkName: "" */))
const _487f6d57 = () => interopDefault(import('../nuxt/pages/~home/index.vue' /* webpackChunkName: "" */))
const _03db0447 = () => interopDefault(import('../nuxt/pages/~profile/index.vue' /* webpackChunkName: "" */))
const _695bfa25 = () => interopDefault(import('../nuxt/pages/~profile/edit.vue' /* webpackChunkName: "" */))
const _7fabdf1d = () => interopDefault(import('../nuxt/pages/~profile/loginHistory.patient.vue' /* webpackChunkName: "" */))
const _7ffde8f6 = () => interopDefault(import('../nuxt/pages/~profile/other.vue' /* webpackChunkName: "" */))
const _7c9317f5 = () => interopDefault(import('../nuxt/pages/~profile/confirm.vue' /* webpackChunkName: "" */))
const _59a74001 = () => interopDefault(import('../nuxt/pages/~questionnaire/result/index.vue' /* webpackChunkName: "" */))
const _92afeee0 = () => interopDefault(import('../nuxt/pages/~chat/index.vue' /* webpackChunkName: "" */))
const _0ac02388 = () => interopDefault(import('../nuxt/pages/~hospital/requirement/result/index.vue' /* webpackChunkName: "" */))
const _8e117756 = () => interopDefault(import('../nuxt/pages/~hospital/introduction/result/index.vue' /* webpackChunkName: "" */))
const _296b78f2 = () => interopDefault(import('../nuxt/pages/~hospital/introduction/history/index.vue' /* webpackChunkName: "" */))
const _0140d92f = () => interopDefault(import('../nuxt/pages/~hospital/requirement/charge/result/index.vue' /* webpackChunkName: "" */))
const _e5cbb614 = () => interopDefault(import('../nuxt/pages/~hospital/introduction/charge/result/index.vue' /* webpackChunkName: "" */))
const _4cb6a71e = () => interopDefault(import('../nuxt/pages/~hospital/introduction/charge/history/index.vue' /* webpackChunkName: "" */))
const _01fd8e2c = () => interopDefault(import('../nuxt/pages/~hospital/introduction/charge/index.vue' /* webpackChunkName: "" */))
const _06053d73 = () => interopDefault(import('../nuxt/pages/~video/video-chat.vue' /* webpackChunkName: "" */))
const _0c306add = () => interopDefault(import('../nuxt/pages/~video/video-chat-leave.vue' /* webpackChunkName: "" */))
const _390bcdc8 = () => interopDefault(import('../nuxt/pages/~telemedicine/index.vue' /* webpackChunkName: "" */))
const _566eb5dd = () => interopDefault(import('../nuxt/pages/~telemedicine/charge/index.vue' /* webpackChunkName: "" */))
const _310a372a = () => interopDefault(import('../nuxt/pages/~medical-consulting/index.vue' /* webpackChunkName: "" */))
const _8f1d67e2 = () => interopDefault(import('../nuxt/pages/~medical-consulting/charge/index.vue' /* webpackChunkName: "" */))
const _5a9dbf5c = () => interopDefault(import('../nuxt/pages/~specialist-chat/index.vue' /* webpackChunkName: "" */))
const _3d1145e7 = () => interopDefault(import('../nuxt/pages/~specialist-chat/charge/index.vue' /* webpackChunkName: "" */))
const _461f8991 = () => interopDefault(import('../nuxt/pages/~invoice-card/charge/index.vue' /* webpackChunkName: "" */))
const _67b62f52 = () => interopDefault(import('../nuxt/pages/~contents/index.vue' /* webpackChunkName: "" */))
const _2762ca81 = () => interopDefault(import('../nuxt/pages/~contents/detail.vue' /* webpackChunkName: "" */))
const _97f3bb6a = () => interopDefault(import('../nuxt/pages/~news/index.vue' /* webpackChunkName: "" */))
const _651136a8 = () => interopDefault(import('../nuxt/pages/~news/detail.vue' /* webpackChunkName: "" */))
const _4f1b27d4 = () => interopDefault(import('../nuxt/pages/~welcome/employeeCodeInput.patient.vue' /* webpackChunkName: "" */))
const _1529f257 = () => interopDefault(import('../nuxt/pages/~welcome/index.patient.vue' /* webpackChunkName: "" */))
const _dfd01cf4 = () => interopDefault(import('../nuxt/pages/~welcome/interview.patient.vue' /* webpackChunkName: "" */))
const _664c43a0 = () => interopDefault(import('../nuxt/pages/~list/team.patient.vue' /* webpackChunkName: "" */))
const _44b19818 = () => interopDefault(import('../nuxt/pages/~questionnaire/index.patient.vue' /* webpackChunkName: "" */))
const _46d03746 = () => interopDefault(import('../nuxt/pages/~questionnaire/confirm.patient.vue' /* webpackChunkName: "" */))
const _60dca88c = () => interopDefault(import('../nuxt/pages/~hospital/requirement/form/index.patient.vue' /* webpackChunkName: "" */))
const _cc0c2b30 = () => interopDefault(import('../nuxt/pages/~hospital/requirement/form/confirm.patient.vue' /* webpackChunkName: "" */))
const _06e5546d = () => interopDefault(import('../nuxt/pages/~hospital/requirement/charge/form/index.patient.vue' /* webpackChunkName: "" */))
const _4b06325b = () => interopDefault(import('../nuxt/pages/~hospital/requirement/charge/form/confirm.patient.vue' /* webpackChunkName: "" */))
const _58d8c477 = () => interopDefault(import('../nuxt/pages/~hospital/introduction/charge/payment.patient.vue' /* webpackChunkName: "" */))
const _0433a7fb = () => interopDefault(import('../nuxt/pages/~payment/index.patient.vue' /* webpackChunkName: "" */))
const _5d64c2e8 = () => interopDefault(import('../nuxt/pages/~telemedicine/charge/payment.patient.vue' /* webpackChunkName: "" */))
const _8b627acc = () => interopDefault(import('../nuxt/pages/~medical-consulting/charge/payment.patient.vue' /* webpackChunkName: "" */))
const _57024e72 = () => interopDefault(import('../nuxt/pages/~specialist-chat/charge/payment.patient.vue' /* webpackChunkName: "" */))
const _5ee045c6 = () => interopDefault(import('../nuxt/pages/~telemedicine/reserve.patient.vue' /* webpackChunkName: "" */))
const _5b9441ab = () => interopDefault(import('../nuxt/pages/~medical-consulting/reserve.patient.vue' /* webpackChunkName: "" */))
const _bd90f4c8 = () => interopDefault(import('../nuxt/pages/~invoice-card/charge/payment.patient.vue' /* webpackChunkName: "" */))
const _42dce452 = () => interopDefault(import('../nuxt/pages/~service/mental-counseling.vue' /* webpackChunkName: "" */))
const _382477e4 = () => interopDefault(import('../nuxt/pages/~service/mental-consultation.vue' /* webpackChunkName: "" */))
const _67a06253 = () => interopDefault(import('../nuxt/pages/~service/index.vue' /* webpackChunkName: "" */))
const _40abdd20 = () => interopDefault(import('../nuxt/pages/~service/health-check/report/index.vue' /* webpackChunkName: "" */))
const _3d7fcc66 = () => interopDefault(import('../nuxt/pages/~health-check/index.patient.vue' /* webpackChunkName: "" */))
const _1d6e593a = () => interopDefault(import('../nuxt/pages/~health-check/complete.patient.vue' /* webpackChunkName: "" */))
const _36c765d4 = () => interopDefault(import('../nuxt/pages/~health-check/data.patient.vue' /* webpackChunkName: "" */))
const _1de4477e = () => interopDefault(import('../nuxt/pages/~health-check/re-examination.patient.vue' /* webpackChunkName: "" */))
const _6c8deffc = () => interopDefault(import('../nuxt/pages/~questionnaire/disease.patient.vue' /* webpackChunkName: "" */))
const _4f0faab1 = () => interopDefault(import('../nuxt/pages/~home/timeline.doctor.vue' /* webpackChunkName: "" */))
const _55f9f956 = () => interopDefault(import('../nuxt/pages/~list/patientList.doctor.vue' /* webpackChunkName: "" */))
const _020d025d = () => interopDefault(import('../nuxt/pages/~questionnaire/select/index.doctor.vue' /* webpackChunkName: "" */))
const _3063292f = () => interopDefault(import('../nuxt/pages/~questionnaire/select/confirm.doctor.vue' /* webpackChunkName: "" */))
const _059273ea = () => interopDefault(import('../nuxt/pages/~questionnaire/detail.doctor.vue' /* webpackChunkName: "" */))
const _99aa2f50 = () => interopDefault(import('../nuxt/pages/~video/create.doctor.vue' /* webpackChunkName: "" */))
const _b12a7140 = () => interopDefault(import('../nuxt/pages/~hospital/requirement/list/index.doctor.vue' /* webpackChunkName: "" */))
const _15388d1c = () => interopDefault(import('../nuxt/pages/~hospital/requirement/list/confirm.doctor.vue' /* webpackChunkName: "" */))
const _7b53df30 = () => interopDefault(import('../nuxt/pages/~hospital/requirement/detail.doctor.vue' /* webpackChunkName: "" */))
const _27700d81 = () => interopDefault(import('../nuxt/pages/~hospital/introduction/form/index.doctor.vue' /* webpackChunkName: "" */))
const _eda0095a = () => interopDefault(import('../nuxt/pages/~hospital/introduction/form/confirm.doctor.vue' /* webpackChunkName: "" */))
const _9d148766 = () => interopDefault(import('../nuxt/pages/~hospital/requirement/charge/list/index.doctor.vue' /* webpackChunkName: "" */))
const _aef5b1c2 = () => interopDefault(import('../nuxt/pages/~hospital/requirement/charge/list/confirm.doctor.vue' /* webpackChunkName: "" */))
const _48d0529d = () => interopDefault(import('../nuxt/pages/~hospital/requirement/charge/detail.doctor.vue' /* webpackChunkName: "" */))
const _2e552d00 = () => interopDefault(import('../nuxt/pages/~hospital/introduction/charge/form/index.doctor.vue' /* webpackChunkName: "" */))
const _f2a358dc = () => interopDefault(import('../nuxt/pages/~hospital/introduction/charge/form/confirm.doctor.vue' /* webpackChunkName: "" */))
const _70e4f3ec = () => interopDefault(import('../nuxt/pages/~hospital/introduction/charge-create/index.doctor.vue' /* webpackChunkName: "" */))
const _d05d14c8 = () => interopDefault(import('../nuxt/pages/~hospital/introduction/charge-create/confirm.doctor.vue' /* webpackChunkName: "" */))
const _dfba380a = () => interopDefault(import('../nuxt/pages/~telemedicine/charge-create/index.doctor.vue' /* webpackChunkName: "" */))
const _def1c966 = () => interopDefault(import('../nuxt/pages/~telemedicine/charge-create/confirm.doctor.vue' /* webpackChunkName: "" */))
const _a977edca = () => interopDefault(import('../nuxt/pages/~telemedicine/create.doctor.vue' /* webpackChunkName: "" */))
const _63c1baad = () => interopDefault(import('../nuxt/pages/~medical-consulting/charge-create/index.doctor.vue' /* webpackChunkName: "" */))
const _1069e502 = () => interopDefault(import('../nuxt/pages/~medical-consulting/charge-create/confirm.doctor.vue' /* webpackChunkName: "" */))
const _ecd78dae = () => interopDefault(import('../nuxt/pages/~medical-consulting/create.doctor.vue' /* webpackChunkName: "" */))
const _ce190b5e = () => interopDefault(import('../nuxt/pages/~specialist-chat/create.doctor.vue' /* webpackChunkName: "" */))
const _219b9a85 = () => interopDefault(import('../nuxt/pages/~specialist-chat/charge-create/index.doctor.vue' /* webpackChunkName: "" */))
const _b2a75152 = () => interopDefault(import('../nuxt/pages/~specialist-chat/charge-create/confirm.doctor.vue' /* webpackChunkName: "" */))
const _dc862fa4 = () => interopDefault(import('../nuxt/pages/~chat/select.vue' /* webpackChunkName: "" */))
const _52a11b1a = () => interopDefault(import('../nuxt/pages/~consultation-summary/index.vue' /* webpackChunkName: "" */))
const _1d087657 = () => interopDefault(import('../nuxt/pages/~event-counting-summary/index.vue' /* webpackChunkName: "" */))
const _ecb2b6f8 = () => interopDefault(import('../nuxt/pages/~invoice-card/create/index.doctor.vue' /* webpackChunkName: "" */))
const _381cdd96 = () => interopDefault(import('../nuxt/pages/~invoice-card/create/confirm.doctor.vue' /* webpackChunkName: "" */))
const _1e1cc770 = () => interopDefault(import('../nuxt/pages/~list/userTreatmentStatus.concierge.vue' /* webpackChunkName: "" */))
const _2800f208 = () => interopDefault(import('../nuxt/pages/~list/userRequestDetailList.concierge.vue' /* webpackChunkName: "" */))
const _29caeb8c = () => interopDefault(import('../nuxt/pages/~list/userList.concierge.vue' /* webpackChunkName: "" */))
const _a035477a = () => interopDefault(import('../nuxt/pages/~list/inspectionEquipment.concierge.vue' /* webpackChunkName: "" */))
const _9bb9ac5c = () => interopDefault(import('../nuxt/pages/~list/inspectionEquipmentReport.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "*",
    component: _c0fc0b5a,
    name: "404-custom"
  }, {
    path: "/top",
    component: _47df9bf0,
    meta: {"permissions":["guest"]},
    name: "top-custom"
  }, {
    path: "/login",
    component: _976be978,
    meta: {"permissions":["guest"]},
    name: "login-custom"
  }, {
    path: "/register",
    component: _32e61718,
    meta: {"permissions":["guest"]},
    name: "register-custom"
  }, {
    path: "/callback",
    component: _175067ba,
    meta: {"permissions":["guest"]},
    name: "callback-custom"
  }, {
    path: "/",
    component: _487f6d57,
    name: "home-custom"
  }, {
    path: "/profile",
    component: _03db0447,
    name: "profile-custom"
  }, {
    path: "/profile/edit",
    component: _695bfa25,
    name: "profile-edit-custom"
  }, {
    path: "/profile/:userId/login-history",
    component: _7fabdf1d,
    name: "profile-login-history"
  }, {
    path: "/profile/:uuid([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})",
    component: _7ffde8f6,
    name: "profile-other-custom"
  }, {
    path: "/profile/confirm",
    component: _7c9317f5,
    name: "profile-confirm-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/questionnaire-result/:questionnaireId([0-9]{1,})",
    component: _59a74001,
    name: "questionnaire-result-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/chat/:chatId",
    component: _92afeee0,
    name: "chat-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-requirement-result/:hospitalConditionId([0-9]{1,})",
    component: _0ac02388,
    name: "hospital-requirement-result-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-introduction-result/:hospitalIntroductionId([0-9]{1,})",
    component: _8e117756,
    name: "hospital-introduction-result-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-introduction-history",
    component: _296b78f2,
    name: "hospital-introduction-history-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-requirement-charge-result/:hospitalConditionId([0-9]{1,})",
    component: _0140d92f,
    name: "hospital-requirement-charge-result-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-introduction-charge-result/:hospitalIntroductionId([0-9]{1,})",
    component: _e5cbb614,
    name: "hospital-introduction-charge-result-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-introduction-charge-history",
    component: _4cb6a71e,
    name: "hospital-introduction-charge-history-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-introduction-charge/:hospitalIntroductionPaymentId([0-9]{1,})",
    component: _01fd8e2c,
    name: "hospital-introduction-charge-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/videoMeetings/:videoMeetingId([0-9]{1,})",
    component: _06053d73,
    name: "video-meeting-custom"
  }, {
    path: "/video-chat-leave",
    component: _0c306add,
    name: "video-chat-leave-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/telemedicine/:telemedicineId([0-9]{1,})",
    component: _390bcdc8,
    name: "telemedicine-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/telemedicine-charge/:telemedicineId([0-9]{1,})",
    component: _566eb5dd,
    name: "telemedicine-charge-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/medical-consulting/:medicalConsultingId([0-9]{1,})",
    component: _310a372a,
    name: "medical-consulting-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/medical-consulting-charge/:medicalConsultingId([0-9]{1,})",
    component: _8f1d67e2,
    name: "medical-consulting-charge-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/specialist-chat/:specialistChatId([0-9]{1,})",
    component: _5a9dbf5c,
    name: "specialist-chat-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/specialist-chat-charge/:specialistChatId([0-9]{1,})",
    component: _3d1145e7,
    name: "specialist-chat-charge-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/invoice-card-charge/:invoiceId([0-9]{1,})",
    component: _461f8991,
    name: "invoice-card-charge-custom"
  }, {
    path: "/contents",
    component: _67b62f52,
    name: "contents-custom"
  }, {
    path: "/contents/:detailId([0-9]{1,})",
    component: _2762ca81,
    name: "contents-detail-custom"
  }, {
    path: "/news",
    component: _97f3bb6a,
    name: "news-list"
  }, {
    path: "/news/:newsId([0-9]{1,})",
    component: _651136a8,
    name: "news-detail-custom"
  }, {
    path: "/employee-code-input",
    component: _4f1b27d4,
    meta: {"permissions":["patient"]},
    name: "employee-code-input"
  }, {
    path: "/welcome",
    component: _1529f257,
    meta: {"permissions":["patient"]},
    name: "welcome-custom"
  }, {
    path: "/welcome-interview",
    component: _dfd01cf4,
    meta: {"permissions":["patient"]},
    name: "welcome-interview-custom"
  }, {
    path: "/team",
    component: _664c43a0,
    meta: {"permissions":["patient"]},
    name: "team-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/questionnaire/:questionnaireId([0-9]{1,})",
    component: _44b19818,
    meta: {"permissions":["patient"]},
    name: "questionnaire-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/questionnaire/:questionnaireId([0-9]{1,})/confirm",
    component: _46d03746,
    meta: {"permissions":["patient"]},
    name: "questionnaire-confirm-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-requirement-form/:hospitalConditionId([0-9]{1,})",
    component: _60dca88c,
    meta: {"permissions":["patient"]},
    name: "hospital-requirement-form-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-requirement-form/:hospitalConditionId([0-9]{1,})/confirm",
    component: _cc0c2b30,
    meta: {"permissions":["patient"]},
    name: "hospital-requirement-form-confirm-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-requirement-charge-form/:hospitalConditionId([0-9]{1,})",
    component: _06e5546d,
    meta: {"permissions":["patient"]},
    name: "hospital-requirement-charge-form-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-requirement-charge-form/:hospitalConditionId([0-9]{1,})/confirm",
    component: _4b06325b,
    meta: {"permissions":["patient"]},
    name: "hospital-requirement-charge-form-confirm-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-requirement-charge/:hospitalIntroductionPaymentId([0-9]{1,})/payment",
    component: _58d8c477,
    meta: {"permissions":["patient"]},
    name: "hospital-introduction-charge-payment-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/payment/:paymentId([0-9]{1,})",
    component: _0433a7fb,
    name: "payment-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/telemedicine-charge/:telemedicineId([0-9]{1,})/payment",
    component: _5d64c2e8,
    meta: {"permissions":["patient"]},
    name: "telemedicine-charge-payment-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/medical-consulting-charge/:medicalConsultingId([0-9]{1,})/payment",
    component: _8b627acc,
    meta: {"permissions":["patient"]},
    name: "medical-consulting-charge-payment-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/specialist-chat-charge/:specialistChatId([0-9]{1,})/payment",
    component: _57024e72,
    meta: {"permissions":["patient"]},
    name: "specialist-chat-charge-payment-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/telemedicine-reserve/:questionnaireId([0-9]{1,})",
    component: _5ee045c6,
    meta: {"permissions":["patient"]},
    name: "telemedicine-reserve-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/medical-consulting-reserve/:questionnaireId([0-9]{1,})",
    component: _5b9441ab,
    meta: {"permissions":["patient"]},
    name: "medical-consulting-reserve-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/invoice-card-charge/:invoiceId([0-9]{1,})/payment",
    component: _bd90f4c8,
    meta: {"permissions":["patient"]},
    name: "invoice-card-charge-payment-custom"
  }, {
    path: "/service/mental/counseling",
    component: _42dce452,
    meta: {"permissions":["patient"]},
    name: "mental-counseling"
  }, {
    path: "/service/mental/consultation",
    component: _382477e4,
    meta: {"permissions":["patient"]},
    name: "mental-consultation"
  }, {
    path: "/service/:appType?",
    component: _67a06253,
    meta: {"permissions":["patient"]},
    name: "service-custom"
  }, {
    path: "/service/health-check/report",
    component: _40abdd20,
    meta: {"permissions":["patient"]},
    name: "service-health-check-report"
  }, {
    path: "/health-check/appointment/:healthCheckId([0-9]{1,})/input",
    component: _3d7fcc66,
    meta: {"permissions":["patient"]},
    name: "health-check-appointment-input"
  }, {
    path: "/health-check/appointment/:healthCheckId([0-9]{1,})/complete",
    component: _1d6e593a,
    meta: {"permissions":["patient"]},
    name: "health-check-appointment-complete"
  }, {
    path: "/health-check/data",
    component: _36c765d4,
    meta: {"permissions":["patient"]},
    name: "health-check-data"
  }, {
    path: "/health-check/re-examination",
    component: _1de4477e,
    meta: {"permissions":["patient"]},
    name: "health-check-re-examination"
  }, {
    path: "/news/:newsId([0-9]{1,})",
    component: _651136a8,
    meta: {"permissions":["patient"]},
    name: "news-detail"
  }, {
    path: "/questionnaire-disease-input/:projectId([0-9]{1,})/:questionnaireId([0-9]{1,})",
    component: _6c8deffc,
    name: "questionnaire-disease-input"
  }, {
    path: "/home/:projectId([0-9]{1,})",
    component: _4f0faab1,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "home-timeline-custom"
  }, {
    path: "/patient-list",
    component: _55f9f956,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "patient-list-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/questionnaire-select",
    component: _020d025d,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "questionnaire-select-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/questionnaire-select/:templateId([0-9]{1,})/confirm",
    component: _3063292f,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "questionnaire-select-confirm-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/questionnaire-detail/:questionnaireId([0-9]{1,})",
    component: _059273ea,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "questionnaire-detail-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/video-chat-create",
    component: _99aa2f50,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "video-chat-create-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-requirement-list",
    component: _b12a7140,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "hospital-requirement-list-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-requirement-list/:templateId([0-9]{1,})/confirm",
    component: _15388d1c,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "hospital-requirement-list-confirm-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-requirement-detail/:hospitalConditionId([0-9]{1,})",
    component: _7b53df30,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "hospital-requirement-detail-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-introduction-form/:hospitalConditionId([0-9]{1,})",
    component: _27700d81,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "hospital-introduction-form-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-introduction-form/:hospitalConditionId([0-9]{1,})/confirm",
    component: _eda0095a,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "hospital-introduction-form-confirm-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-requirement-charge-list",
    component: _9d148766,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "hospital-requirement-charge-list-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-requirement-charge-list/:templateId([0-9]{1,})/confirm",
    component: _aef5b1c2,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "hospital-requirement-charge-list-confirm-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-requirement-charge-detail/:hospitalConditionId([0-9]{1,})",
    component: _48d0529d,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "hospital-requirement-charge-detail-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-introduction-charge-form/:hospitalConditionId([0-9]{1,})",
    component: _2e552d00,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "hospital-introduction-charge-form-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-introduction-form/:hospitalConditionId([0-9]{1,})/confirm",
    component: _f2a358dc,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "hospital-introduction-charge-form-confirm-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-introduction-charge-create/:hospitalIntroductionId([0-9]{1,})",
    component: _70e4f3ec,
    name: "hospital-introduction-charge-create-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/hospital-introduction-charge-create-confirm/:hospitalIntroductionId([0-9]{1,})",
    component: _d05d14c8,
    name: "hospital-introduction-charge-create-confirm-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/telemedicine-charge-create/:telemedicineId([0-9]{1,})",
    component: _dfba380a,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "telemedicine-charge-create-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/telemedicine-charge-create/:telemedicineId([0-9]{1,})/confirm",
    component: _def1c966,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "telemedicine-charge-create-confirm-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/telemedicine-create",
    component: _a977edca,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "telemedicine-create-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/medical-consulting-charge-create/:medicalConsultingId([0-9]{1,})",
    component: _63c1baad,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "medical-consulting-charge-create-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/medical-consulting-charge-create/:medicalConsultingId([0-9]{1,})/confirm",
    component: _1069e502,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "medical-consulting-charge-create-confirm-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/medical-consulting-create",
    component: _ecd78dae,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "medical-consulting-create-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/free-specialist-chat-create",
    component: _ce190b5e,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "free-specialist-chat-create-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/paid-specialist-chat-create",
    component: _ce190b5e,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "paid-specialist-chat-create-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/specialist-chat-charge-create/:specialistChatId([0-9]{1,})",
    component: _219b9a85,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "specialist-chat-charge-create-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/specialist-chat-charge-create/:specialistChatId([0-9]{1,})/confirm",
    component: _b2a75152,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "specialist-chat-charge-create-confirm-custom"
  }, {
    path: "/chat-select/:projectId([0-9]{1,})",
    component: _dc862fa4,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "chat-select"
  }, {
    path: "/consultation-summary",
    component: _52a11b1a,
    name: "consultation-summary-custom"
  }, {
    path: "/event-counting-summary",
    component: _1d087657,
    name: "event-counting-summary-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/invoice-card-create",
    component: _ecb2b6f8,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "invoice-card-create-custom"
  }, {
    path: "/projects/:projectId([0-9]{1,})/invoice-card-create/confirm",
    component: _381cdd96,
    meta: {"permissions":["doctor","nurse","registered_dietitian","clinical_psychologist","concierge"]},
    name: "invoice-card-create-confirm-custom"
  }, {
    path: "/user-treatment-status-list",
    component: _1e1cc770,
    meta: {"permissions":"concierge"},
    name: "user-treatment-status-list"
  }, {
    path: "/user-request-detail-list",
    component: _2800f208,
    meta: {"permissions":"concierge"},
    name: "user-request-detail-list"
  }, {
    path: "/user-list",
    component: _29caeb8c,
    meta: {"permissions":"concierge"},
    name: "user-list"
  }, {
    path: "/inspection-equipment-list",
    component: _a035477a,
    meta: {"permissions":"concierge"},
    name: "inspection-equipment-list"
  }, {
    path: "/inspection-equipment-report/:projectId([0-9]{1,})",
    component: _9bb9ac5c,
    meta: {"permissions":["concierge","doctor","nurse","patient"]},
    name: "inspection-equipment-report"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
